import React, { useState } from 'react';

import { faPlugCircleMinus } from '@fortawesome/pro-regular-svg-icons';

import EmptyState from 'shared/empty_state';

import { GoogleGrant } from 'components/nylas/v3/grant/google';
import { MicrosoftGrant } from 'components/nylas/v3/grant/microsoft';

import type { Grant, GrantPaths } from 'components/nylas/v3/types';

interface Props {
  features: {
    outlook: boolean;
  };
  nylas: {
    grant: Grant | null;
    paths: GrantPaths;
  };
}

export default function CrmIntegrationSettings({ features, nylas }: Props) {
  const [nylasGrant, setNylasGrant] = useState(nylas.grant);

  const grantProps = {
    grant: nylasGrant,
    paths: nylas.paths,
    onDestroy: () => setNylasGrant(null),
  };

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Connected Providers</h6>

      {!nylasGrant && <>
        <EmptyState
          bodyText={`
            To automatically log emails as CRM Activities, connect an email provider from the list below.
            You can only connect one account at a time.
          `}
          header="No Providers Connected"
          icon={faPlugCircleMinus}
          variant="inline"
        />

        <h6>Available Providers</h6>
      </>}

      <div className="d-flex flex-column gap-3">
        {(!nylasGrant || nylasGrant.providerName === 'google') &&
          <GoogleGrant {...grantProps} />
        }
        {(!nylasGrant || nylasGrant.providerName === 'microsoft') && features.outlook &&
          <MicrosoftGrant {...grantProps} />
        }
      </div>
    </div>
  );
}
